import { moduleNamespace } from '@Store/config.store';

export const addNamespace = (action: string) => moduleNamespace + '/' + action;
